import React, { useState } from "react";
import styles from "./Inputs.module.scss";

const DurationInput = ({ label, value, onChange }) => {
  const [duration, setDuration] = useState(value || { days: "", hours: "", minutes: "" });

  const handleChange = (event) => {
    const { name, value } = event.target;
    
    const newValue = value === "" ? "" : parseInt(value, 10) || "";

    const newDuration = { ...duration, [name]: newValue };
    setDuration(newDuration);
    onChange(newDuration);
  };

  return (
    <div className={styles.inputContainer}>
      <label className={styles.label}>{label}</label>
      <div className={styles.durationFields}>
        <input
          type="number"
          name="days"
          value={duration.days}
          onChange={handleChange}
          placeholder="Days"
        />
        <input
          type="number"
          name="hours"
          value={duration.hours}
          onChange={handleChange}
          placeholder="Hours"
        />
        <input
          type="number"
          name="minutes"
          value={duration.minutes}
          onChange={handleChange}
          placeholder="Minutes"
        />
      </div>
    </div>
  );
};

export default DurationInput;
